<template>
    <div class="steps bg-darkest lightest text-center">
        <ul class="d-flex align-items-center">
            <li 
                class="d-flex align-items-center lightest p-3 m-2 pointer" 
                v-for="step in steps" @click="updateCurrentStep($event, step.number)" 
                :class="{ active: step.number === currentStep }">

                <span class="number radius-circle">{{ step.number }}</span>
                <span>{{ step.label }}</span>
            </li>
        </ul>
    </div>

</template>

<script>
    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                steps: [
                    { number: 1, label: 'Details' },
                    { number: 2, label: 'Commissions' },
                ]
            }
        },
        methods: {
            updateCurrentStep: function(e, step) {
                this.$emit('changeCurrentStep', step);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// AgentSteps.vue?521039df